import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import "@/style/global.css"
import '@/assets/tailwind.css'
import './registerServiceWorker'
import router from './router'
// import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
export const siteUrlApiUpload = 'https://api.keshik6.ir/storage/uploads/'
const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(pinia)
app.mount('#app')
